import { render, staticRenderFns } from "./DataViz.vue?vue&type=template&id=5438b146&"
import script from "./DataViz.vue?vue&type=script&lang=js&"
export * from "./DataViz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports